import React from "react";
import { Link, Outlet } from "react-router-dom";
import { Button, Container } from "semantic-ui-react";
import SpeedDialComponent from "../SpeedDial/SpeedDialComponent"

function AnnualRevenu() {
  //
  return (
    <>
      <h1 className="titrePatient">Statistiques</h1>
      <Container text textAlign="center" className="graphique">
        <Link to="Years">
          <Button className="IconFixDopdown" color="orange">
            Annuel
          </Button>
        </Link>
        <Link to="Months">
          <Button className="IconFixDopdown" color="yellow">
            Mensuel
          </Button>
        </Link>
        <Link to="Weeks">
          <Button className="IconFixDopdown" color="purple">
            Hébdo
          </Button>
        </Link>
        <Link to="Day">
          <Button className="IconFixDopdown" color="teal">
            Journalier
          </Button>
        </Link>
        <Link to="ByProducts">
          <Button className="IconFixDopdown" color="olive">
            Par Acte
          </Button>
        </Link>
        {/* <Link to="/">
          <Button
            //  floated="right"
            className="IconFixDopdown"
            color="blue"
          >
            Accueil
          </Button>
        </Link> */}
      </Container>

      <Container className="graphHeight">
        <Outlet />
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>

      </Container>

      <SpeedDialComponent />
    </>
  );
}

export default AnnualRevenu;
